export default "__VITE_ASSET__HeyO7Dzj__"